import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect, Route, Switch } from "react-router";
import PropertiesWithProjects from "./PropertiesWithProjects";
import ProjectProperties from "./ProjectProperties";
import BuildingUnits from "./BuildingUnits";
import OwnerEjariServices from "../Owner";
import LeasedContextWrapper from "@eres/ejari-core/contexts/LeasedContext";

class OwnerLeased extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <LeasedContextWrapper>
			<Switch>
				<Route path={ pp + "/projects" } exact={ true } component={ PropertiesWithProjects }/>
				<Route
					path={ pp + "/properties/:rentalStatus" } exact={ true }
					component={ ProjectProperties }/>
				<Route path={ pp + "/units/:rentalStatus" } exact={ true } component={ BuildingUnits }/>
				<Route
					path={ pp + "/property/:propertyTypeId/:propertyId/:isFreeHold/:isWallet/ejarisvc" }
					component={ OwnerEjariServices }/>
				<Route path={ pp } exact={ true }>
					<Redirect to={ pp + "/projects" }/>
				</Route>
			</Switch>
		</LeasedContextWrapper>;
	}
}

export default OwnerLeased;
